import React, { useState } from "react";
import axios from "axios";
import { Button, TextField } from "@mui/material";
import { useAlert } from "react-alert";
import { URL } from "../../constants/userConstants";
import { API } from "../../actions/userAction";

export default function ManualWithdraw() {
  const alert = useAlert();
  const [userId, setUserId] = useState("");
  const [amount, setAmount] = useState("");

  const handleWithdraw = async () => {
    try {
     await API.post("/api/admin/manual-withdraw", {
        userId,
        amount,
      });

      alert.success("Withdraw Completed");
      setUserId("");
      setAmount("");
    } catch (err) {
      alert.error("Withdraw Failed");
    }
  };

  return (
    <div style={{ padding: 20 }}>
      <h3>Manual Withdraw</h3>

      <TextField
        label="User ID"
        fullWidth
        margin="normal"
        value={userId}
        onChange={(e) => setUserId(e.target.value)}
      />

      <TextField
        label="Amount"
        type="number"
        fullWidth
        margin="normal"
        value={amount}
        onChange={(e) => setAmount(e.target.value)}
      />

      <Button
        variant="contained"
        color="error"
        onClick={handleWithdraw}
      >
        Complete Withdraw
      </Button>
    </div>
  );
}
